/*
 * @Author: sillyy
 * @LastEditors: shero
 * @Description: 教材列表布局
 * @Date: 2019-02-22 12:57:38
 * @LastEditTime: 2019-03-19 13:36:22
 */

 export default {
    banOperate: true,
    props: [
        {
            attr: 'name',
            name: '教材名称',
            slot: 'name'
        },
        {
            attr: 'toobject',
            name: '适用对象',
            slot: 'toobject'
        },
        {
            attr: 'price',
            name: '价格',
            slot: 'price'
        },
        {
            attr: 'userlimit',
            name: '用户数'
        },
        {
            attr: 'coursenum',
            name: '课程数量'
        },
        {
            attr: 'validityFrom',
            name: '有效期从',
            slot: 'validityFrom'
        },
        {
            attr: 'validityTo',
            name: '有效期至',
            slot: 'validityTo'
        },
        {
            attr: 'coursetype',
            name: '课程类型',
            slot: 'coursetype'
        },
        {
            attr: 'status',
            name: '状态',
            slot: 'status'
        }
    ]
 }